<template>
  <div>
    <base-header class="pb-7 pt-5 pt-md-7 bg-gradient-info">
      <b-row class="align-items-center">
        <b-col>
          <h6 class="h2 text-white d-inline-block mb-0">
            <i class="fa fa-clipboard-list mr-2"></i>Log Aktivitas Sistem
          </h6>
          <p class="text-white-50 mb-0 mt-1" style="font-size:0.85rem;">
            Catatan login, CRUD, sync OneData, dan event sistem lainnya
          </p>
        </b-col>
      </b-row>

      <b-row class="mt-4">
        <b-col xl="3" md="6">
          <stats-card type="gradient-info" icon="fa fa-database" class="mb-4">
            <h5 class="card-title text-uppercase text-muted mb-0">Total Log</h5>
            <span class="h2 font-weight-bold mb-0">{{ formatNum(summary.total_all) }}</span>
          </stats-card>
        </b-col>
        <b-col xl="3" md="6">
          <stats-card type="gradient-success" icon="fa fa-clock" class="mb-4">
            <h5 class="card-title text-uppercase text-muted mb-0">24 Jam Terakhir</h5>
            <span class="h2 font-weight-bold mb-0">{{ formatNum(summary.latest_24h) }}</span>
          </stats-card>
        </b-col>
        <b-col xl="3" md="6">
          <stats-card type="gradient-orange" icon="fa fa-exclamation-triangle" class="mb-4">
            <h5 class="card-title text-uppercase text-muted mb-0">Login Gagal Hari Ini</h5>
            <span class="h2 font-weight-bold mb-0">{{ formatNum(summary.login_failed_today) }}</span>
          </stats-card>
        </b-col>
        <b-col xl="3" md="6">
          <stats-card type="gradient-purple" icon="fa fa-tags" class="mb-4">
            <h5 class="card-title text-uppercase text-muted mb-0">Kategori</h5>
            <span class="h2 font-weight-bold mb-0">{{ (summary.by_category || []).length }}</span>
          </stats-card>
        </b-col>
      </b-row>
    </base-header>

    <b-container fluid class="mt--6">
      <b-card no-body>
        <b-card-header class="border-0">
          <b-row align-v="center">
            <b-col><h3 class="mb-0">Filter Log</h3></b-col>
            <b-col cols="auto" class="text-right">
              <b-button size="sm" variant="outline-danger" @click="purgeLogs">
                <i class="fa fa-trash"></i> Purge &gt; 90 hari
              </b-button>
              <b-button size="sm" variant="outline-secondary" @click="resetFilter">
                <i class="fa fa-redo"></i> Reset
              </b-button>
              <b-button size="sm" variant="info" @click="loadLogs">
                <i class="fa fa-search"></i> Cari
              </b-button>
            </b-col>
          </b-row>
        </b-card-header>
        <b-card-body class="pt-2">
          <b-row>
            <b-col md="3">
              <b-form-group label="Kategori" label-size="sm" class="mb-2">
                <b-form-select v-model="filter.category" :options="categoryOptions" size="sm"></b-form-select>
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group label="Event" label-size="sm" class="mb-2">
                <b-form-select v-model="filter.event" :options="eventOptions" size="sm"></b-form-select>
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group label="Status" label-size="sm" class="mb-2">
                <b-form-select v-model="filter.status" :options="statusOptions" size="sm"></b-form-select>
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group label="Username" label-size="sm" class="mb-2">
                <b-form-input v-model="filter.username" size="sm" placeholder="username..."></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group label="Dari Tanggal" label-size="sm" class="mb-2">
                <b-form-input v-model="filter.from" type="date" size="sm"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group label="Sampai Tanggal" label-size="sm" class="mb-2">
                <b-form-input v-model="filter.to" type="date" size="sm"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group label="Pencarian (summary/event)" label-size="sm" class="mb-2">
                <b-form-input v-model="filter.search" size="sm" placeholder="Cari di summary..." @keyup.enter="loadLogs"></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
        </b-card-body>
      </b-card>

      <b-card no-body class="mt-3 mb-5">
        <b-card-header class="border-0">
          <b-row align-v="center">
            <b-col><h3 class="mb-0">Daftar Log</h3></b-col>
            <b-col cols="auto"><small class="text-muted">{{ formatNum(totalLogs) }} log ditemukan</small></b-col>
          </b-row>
        </b-card-header>
        <div class="table-responsive">
          <table class="table table-sm table-hover align-items-center mb-0">
            <thead class="thead-light">
              <tr>
                <th>Waktu</th>
                <th>User</th>
                <th>Role</th>
                <th>Kategori</th>
                <th>Event</th>
                <th>Entity</th>
                <th>Summary</th>
                <th>Status</th>
                <th>IP</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="!logs.length">
                <td colspan="10" class="text-center text-muted py-4">Tidak ada log ditemukan</td>
              </tr>
              <tr v-for="log in logs" :key="log.id">
                <td><small>{{ formatTime(log.created_at) }}</small></td>
                <td><strong>{{ log.username || '-' }}</strong></td>
                <td><b-badge :variant="roleVariant(log.role_name)">{{ log.role_name || '-' }}</b-badge></td>
                <td><b-badge variant="light">{{ log.category || '-' }}</b-badge></td>
                <td><code>{{ log.event }}</code></td>
                <td><small>{{ log.entity || '-' }}<br v-if="log.entity_id"><span class="text-muted">{{ log.entity_id || '' }}</span></small></td>
                <td style="max-width: 280px;">
                  <small :title="log.summary || ''" style="display:-webkit-box; -webkit-line-clamp:2; -webkit-box-orient:vertical; overflow:hidden; text-overflow:ellipsis; word-break:break-word;">
                    {{ truncateSummary(log.summary) }}
                  </small>
                </td>
                <td><b-badge :variant="statusVariant(log.status)">{{ log.status }}</b-badge></td>
                <td><small class="text-muted">{{ log.ip_address || '-' }}</small></td>
                <td>
                  <b-button size="sm" variant="outline-info" @click="viewLog(log)" title="Lihat detail"><i class="fa fa-eye"></i></b-button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="card-footer d-flex justify-content-between align-items-center" v-if="totalLogs > perPage">
          <small class="text-muted">Halaman {{ filter.page }} dari {{ totalPages }}</small>
          <b-pagination
            v-model="filter.page"
            :total-rows="totalLogs"
            :per-page="perPage"
            size="sm"
            class="mb-0"
            @change="onPageChange"
          ></b-pagination>
        </div>
      </b-card>
    </b-container>

    <!-- Detail modal -->
    <b-modal id="modal-log-detail" size="lg" title="Detail Log" ok-only>
      <div v-if="selectedLog">
        <b-row>
          <b-col md="6"><strong>ID:</strong> {{ selectedLog.id }}</b-col>
          <b-col md="6"><strong>Waktu:</strong> {{ formatTime(selectedLog.created_at) }}</b-col>
          <b-col md="6"><strong>User:</strong> {{ selectedLog.username || '-' }}</b-col>
          <b-col md="6"><strong>Role:</strong> {{ selectedLog.role_name || '-' }}</b-col>
          <b-col md="6"><strong>Event:</strong> <code>{{ selectedLog.event }}</code></b-col>
          <b-col md="6"><strong>Kategori:</strong> {{ selectedLog.category || '-' }}</b-col>
          <b-col md="6"><strong>Entity:</strong> {{ selectedLog.entity || '-' }}</b-col>
          <b-col md="6"><strong>Entity ID:</strong> {{ selectedLog.entity_id || '-' }}</b-col>
          <b-col md="6"><strong>HTTP:</strong> {{ selectedLog.http_method }} {{ selectedLog.http_path }}</b-col>
          <b-col md="6"><strong>Status HTTP:</strong> {{ selectedLog.http_status || '-' }}</b-col>
          <b-col md="6"><strong>IP:</strong> {{ selectedLog.ip_address || '-' }}</b-col>
          <b-col md="6"><strong>Status:</strong> <b-badge :variant="statusVariant(selectedLog.status)">{{ selectedLog.status }}</b-badge></b-col>
        </b-row>
        <hr>
        <p><strong>Summary:</strong></p>
        <p class="text-muted">{{ selectedLog.summary || '-' }}</p>
        <p v-if="selectedLog.note"><strong>Note:</strong> {{ selectedLog.note }}</p>
        <p><strong>User Agent:</strong></p>
        <small class="text-muted">{{ selectedLog.user_agent || '-' }}</small>
        <p class="mt-3"><strong>Payload:</strong></p>
        <pre class="bg-light p-2" style="font-size:0.78rem; max-height:200px; overflow:auto;">{{ formatJson(selectedLog.payload) }}</pre>
        <p v-if="selectedLog.changes"><strong>Changes:</strong></p>
        <pre v-if="selectedLog.changes" class="bg-light p-2" style="font-size:0.78rem; max-height:200px; overflow:auto;">{{ formatJson(selectedLog.changes) }}</pre>
      </div>
    </b-modal>
  </div>
</template>

<script>
import BaseHeader from "@/components/admin/BaseHeader";
import axios from "axios";
import authHeader from "@/services/auth-header";
import { baseURL } from "@/constants";

export default {
  name: "AuditLog",
  components: { BaseHeader },
  data: function () {
    return {
      summary: { total_all: 0, latest_24h: 0, login_failed_today: 0, by_category: [], by_event: [] },
      logs: [],
      totalLogs: 0,
      perPage: 50,
      selectedLog: null,
      filter: {
        page: 1,
        category: null,
        event: null,
        status: null,
        username: "",
        from: "",
        to: "",
        search: ""
      },
      categoryOptions: [
        { value: null, text: "Semua Kategori" },
        { value: "auth", text: "Auth (Login/Logout)" },
        { value: "crud", text: "CRUD" },
        { value: "sync", text: "Sync OneData" },
        { value: "tracer", text: "Tracer" },
        { value: "system", text: "Sistem" },
        { value: "other", text: "Lainnya" }
      ],
      eventOptions: [
        { value: null, text: "Semua Event" },
        { value: "login", text: "login" },
        { value: "login_failed", text: "login_failed" },
        { value: "logout", text: "logout" },
        { value: "create", text: "create" },
        { value: "update", text: "update" },
        { value: "delete", text: "delete" },
        { value: "sync_start", text: "sync_start" },
        { value: "sync_finish", text: "sync_finish" },
        { value: "tracer_submit", text: "tracer_submit" },
        { value: "backup", text: "backup" }
      ],
      statusOptions: [
        { value: null, text: "Semua Status" },
        { value: "success", text: "Success" },
        { value: "failed", text: "Failed" },
        { value: "error", text: "Error" }
      ]
    };
  },
  computed: {
    totalPages: function () {
      return Math.ceil(this.totalLogs / this.perPage);
    }
  },
  created: function () {
    this.loadSummary();
    this.loadLogs();
  },
  methods: {
    loadSummary: function () {
      var self = this;
      axios.get(baseURL + "/audit-logs/summary", { headers: authHeader() })
        .then(function (res) { self.summary = res.data; })
        .catch(function () {});
    },
    loadLogs: function () {
      var self = this;
      self.$store.commit("SHOW_LOADING", "Memuat log...");
      var params = { per_page: self.perPage };
      Object.keys(self.filter).forEach(function (k) {
        if (self.filter[k] !== null && self.filter[k] !== '') params[k] = self.filter[k];
      });
      axios.get(baseURL + "/audit-logs", { headers: authHeader(), params: params })
        .then(function (res) {
          self.logs = res.data.data;
          self.totalLogs = res.data.total;
          self.$store.commit("HIDE_LOADING");
        })
        .catch(function () {
          self.$store.commit("HIDE_LOADING");
        });
    },
    onPageChange: function (page) {
      this.filter.page = page;
      this.loadLogs();
    },
    resetFilter: function () {
      this.filter = { page: 1, category: null, event: null, status: null, username: "", from: "", to: "", search: "" };
      this.loadLogs();
    },
    viewLog: function (log) {
      this.selectedLog = log;
      this.$bvModal.show("modal-log-detail");
    },
    purgeLogs: function () {
      var self = this;
      self.$swal({
        title: "Hapus log lebih dari 90 hari?",
        text: "Log akan dihapus permanen.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        confirmButtonText: "Ya, hapus",
        cancelButtonText: "Batal"
      }).then(function (result) {
        if (!result.value) return;
        axios.delete(baseURL + "/audit-logs/purge?days=90", { headers: authHeader() })
          .then(function (res) {
            self.$swal({ icon: "success", title: "Berhasil", text: res.data.message + " (" + res.data.deleted + " dihapus)" });
            self.loadSummary();
            self.loadLogs();
          })
          .catch(function () {
            self.$swal({ icon: "error", title: "Gagal" });
          });
      });
    },
    formatTime: function (ts) {
      if (!ts) return "-";
      var d = new Date(ts);
      return d.toLocaleString("id-ID", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit", second: "2-digit" });
    },
    formatNum: function (n) { return Number(n || 0).toLocaleString("id-ID"); },
    truncateSummary: function (s) {
      if (!s) return "-";
      var max = 120;
      return s.length > max ? s.substring(0, max) + "…" : s;
    },
    formatJson: function (v) { if (!v) return "(kosong)"; try { return JSON.stringify(v, null, 2); } catch (e) { return String(v); } },
    roleVariant: function (r) {
      var m = { admin: "danger", kaprodi: "primary", dekan: "warning", surveyor: "info", alumni: "secondary", ketua_upt: "success" };
      return m[r] || "light";
    },
    statusVariant: function (s) {
      if (s === "success") return "success";
      if (s === "failed") return "warning";
      return "danger";
    }
  }
};
</script>
